<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="100px">
      <el-form-item label="套餐名称:" prop="packageName">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.packageName"
          placeholder="请输入30字以内套餐名称"
          clearable
          style="width:500px"
        />
      </el-form-item>
      <el-form-item label="搭配模块:" prop="moduleList">
        <el-checkbox-group v-model="data.moduleList">
          <el-checkbox label="marketing">营销模块</el-checkbox>
          <el-checkbox label="crm">CRM模块</el-checkbox>
          <el-checkbox label="account" :disabled="true" checked>账号模块</el-checkbox>
          <el-checkbox label="companyManage" :disabled="true" checked>公司管理模块</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="有效期:" prop="validity">
        <el-input
          v-model.number="data.validity"
          oninput="value=value.replace(/[^\d.]/g,'')"
          style="width:500px"
        ></el-input> 月
        <!-- <el-input-number v-model="data.validity" controls-position="right" :min="1"></el-input-number> -->
      </el-form-item>
      <el-form-item label="账号数:" prop="accountNumMax">
        <el-input
          v-model.number="data.accountNumMax"
          oninput="value=value.replace(/[^\d.]/g,'')"
          style="width:500px"
        ></el-input>
        <!-- <el-input-number v-model="data.accountNumMax" controls-position="right" :min="1"></el-input-number> -->
      </el-form-item>
      <el-form-item label="价格:" prop="price">
        <el-input
          v-model.number="data.price"
          type="number"
          style="width:500px"
        ></el-input> 元
        <!-- <el-input-number v-model="data.price" controls-position="right" :min="0"></el-input-number> -->
        <span class="tips-text">（价格输入为0时免费）</span>
      </el-form-item>
      <el-form-item label="说明:" prop="detail">
        <editor v-if="data.introduction || !data.packageId" v-model="data.introduction" :editorId="currentUserId" :editorContent="data.introduction" />
      </el-form-item>
      <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Editor from "@/components/wangEditor";
import { packageSave, packageDetail } from "@/api/saas/package";

export default {
  components: {
    Editor
  },
  data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      checkedModules: ['companyManage','account'],
      rules: {
        packageName: [
          { required: true, message: "请输入套餐名称", trigger: "change" }
        ],
        moduleList: [
          { required: true, message: "请选择套餐模块", trigger: "change" }
        ],
        validity: [
          { required: true, message: "请输入套餐有效期", trigger: "change" },
          { required: true, validator: this.checkNum, trigger:'change'}
        ],
        accountNumMax: [
          { required: true, message: "请输入账户最大数", trigger: "change" }
        ],
        price: [
          { required: true, message: "请输入正确的套餐价格", trigger: "change" }
        ]
      },
      data: {
        accountNumMax: null,
        introduction: null,
        moduleList: [],
        packageName: null,
        price: 0,
        validity: null,
        packageId: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  mounted() {
    this.data.packageId = this.$route.query.packageId;
    // 设置
    if (this.data.packageId) {
      this.queryDetail();
      this.$route.meta.title = '编辑套餐'
      this.$store.state.tagsView.visitedViews.map(item => {
        if(item.path === this.$route.path) {
          item.title = '编辑套餐'
        }
      })
    }else {
      this.$route.meta.title = '添加套餐'
      this.$store.state.tagsView.visitedViews.map(item => {
        if(item.path === this.$route.path) {
          item.title = '添加套餐'
        }
      })
    }
  },
  methods: {
    checkNum (rule, value, callback) {
      // 必填
      if(value == 0) {
        callback(new Error("请输入大于0的有效期"))
      } else {
        callback()
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          if(this.data.moduleList.length<=2) {
            this.msgWarning('请至少选择一个非默认模块')
            return
          }
          packageSave(this.data)
            .then(response => {
              this.$message({
                message: this.data.packageId ? "编辑套餐成功" : "新增套餐成功",
                type: "success"
              });
              this.$router.go(-1);
            })
            .catch(error => {
              this.loading = false;
            });
        }
      });
    },
    queryDetail() {
      packageDetail({
        packageId: this.data.packageId
      })
        .then(response => {
          this.data = response.data;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>